import { useState } from 'react'
import type { MediaType } from '@/lib/types'

/**
 * Poster art comes from Seerr/TMDB and is the first thing to disappear when the
 * home server is down, so the fallback has to look intentional rather than
 * broken: a blank flap with the title's initial set in the board face. No
 * gradient, no placeholder glyph — an empty slot on a board is a normal sight.
 */
export function PosterImage({
  src,
  title,
  mediaType,
  className = '',
}: {
  src: string | null
  title: string
  mediaType: MediaType
  className?: string
}) {
  const [failed, setFailed] = useState(false)
  const showImage = src !== null && !failed

  return (
    <div
      className={`relative shrink-0 overflow-hidden rounded-[3px] border border-line bg-elevated ${className}`}
    >
      {showImage ? (
        <img
          src={src}
          alt=""
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
          className="size-full object-cover"
        />
      ) : (
        <div className="flex size-full flex-col items-center justify-center gap-0.5 p-1 text-center">
          <span aria-hidden="true" className="signage text-lg leading-none text-faint">
            {title.slice(0, 1).toUpperCase()}
          </span>
          <span aria-hidden="true" className="signage text-[7px] leading-none text-faint/70">
            {mediaType === 'tv' ? 'Series' : 'Film'}
          </span>
        </div>
      )}
    </div>
  )
}
